import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        pushBrowser(context, data) {
            return pushModel(context, 'browsers', data)
        }
    }
}
